import { GetProfileDto } from "../Dto";

export interface ProfileEntity extends GetProfileDto {
  roleId: string;
  isActive: boolean;
}

export namespace ProfileEntity {
  export function fromJSON(json): ProfileEntity {
    return {
      binusianId: json.binusianID,
      binusianName: json.binusianName,
      email: json.email,
      businessUnit: json.businessUnit,
      department: json.department,
      roleId: json.roleID,
      title: json.title,
      isActive: !json.isDeleted,
    };
  }
}
